import { useMsal } from '@azure/msal-react';
import { ICommandBarItemProps } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { RootState } from 'app/store';
import saveAs from 'file-saver';
import {
    EViewType,
    emitCustomEvent
} from 'global/Application';
import { MsalTokenSource } from 'global/DataSources/MsalTokenSource';
import { IComponentContextMenu } from 'model/Application';
import { useEffect, useMemo } from "react";
import { ConnectedProps, connect, useDispatch } from 'react-redux';
import { AppDataSource } from '../../global/DataSources/AppDataSource';
import { setProcessing } from '../../global/Reducer/statusSlice';
import GroupConfigurationSnapshotContext from './GroupConfigurationSnapshotContext';
import NonStandardsGlobalGridView from './NonStandardsGlobalGridView';
import NonStandardTemplateGridView from './NonStandardTemplateGridView';
import NonStandardTemplateWizard from './NonStandardTemplateWizard';


interface INonStandardTemplates extends TComponentConnectedProps, IComponentContextMenu {
   // plan?: FAM.IPlan;
    //benefits?: FAM.IBenefit[];
}

const NonStandardTemplates = (props: INonStandardTemplates) => {

    const disabled = props.state.status.viewType !== EViewType.Modify;

    const dispatch = useDispatch();

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [nonStandardTemplateWizardIsOpen, { setTrue: nonStandardTemplateWizardOpen, setFalse: nonStandardTemplateWizardClose }] = useBoolean(false);

    useEffect(() => {
        document.title = `Plan`;

        //if (plan?.name)
        //    document.title = `Plan | ${plan?.name}`;

    }, []);

    const contextMenu = useMemo(() => {

        const menu: ICommandBarItemProps[] = [];

        if (!disabled) {
            // menu.push({
            //     key: 'groupConfiguration.nonStandardTemplate.add',
            //     name: 'Add',
            //     iconProps: { iconName: 'Generate' },
            //     onClick: (event, item) => {
            //         //event?.preventDefault();
            //         //event?.stopPropagation();
            //         nonStandardTemplateWizardOpen();
            //     },
            // },);
        }

        // NSE 
        menu.push({
            key: 'nse',
            text: 'Non-Standard Extract',
            title: 'Generate Non-Standard Extract',
            iconProps: { iconName: 'Generate' },
            onClick: () => {
                (async () => {
                    try {
                        dispatch(setProcessing(true));
                        const excelExtractImport = await import("global/ExcelExtract")
                        const { NonstandardExcelGeneration } = excelExtractImport;
                        const result = await NonstandardExcelGeneration(props.state, dataSource)
                        const fileName = `NSE-${props.state.data.snapshot?.bcbs_name}(${props.state.data.snapshot?.bcbs_groupconfigurationsnapshotid})-${new Date().getTime()}.xlsx`;
                        saveAs(result.file, fileName);
                    } catch (error) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: error
                        });
                    } finally {
                        dispatch(setProcessing(false));
                    }
                })();
            }
        });
        
        return { items: menu, key: 'nsTemplates' };
    }, [disabled]);

    return <GroupConfigurationSnapshotContext contextMenu={contextMenu}>
        {props.state.data.json?.nonStandardTemplates  &&
        <>
            <NonStandardTemplateWizard
            isOpen={nonStandardTemplateWizardIsOpen}
            onCancel={nonStandardTemplateWizardClose}
            onDismiss={nonStandardTemplateWizardClose}
            />
            <NonStandardTemplateGridView
            nonStandardTemplates={props.state.data.json.nonStandardTemplates}
            />
            <NonStandardsGlobalGridView />
        </>
        }
    </GroupConfigurationSnapshotContext>
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connect(mapStateToProps)(NonStandardTemplates)